/* =============================================
   Corporate Gifting Popup — Studio Ode (C-06)

   One popup per `.ode-corp-gifting` block on the page.
   The "Contact us" CTA opens the popup; Submit opens
   WhatsApp with the form values pre-drafted as a
   message — no Shopify contact form, no email routing.

   The WhatsApp number is set per block via
   `block.settings.whatsapp_number` and read off the
   overlay's `data-whatsapp` attribute at runtime.

   Page chrome (header, breadcrumbs) is hidden while
   open via `body.ode-corp-gifting-open` — same pattern
   as the bespoke-quote popup and the inquiry-forms popup.
   ============================================= */

(function () {
  'use strict';

  function digitsOnly(str) {
    return String(str || '').replace(/[^0-9]/g, '');
  }

  function getValue(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? (el.value || '').trim() : '';
  }

  function buildMessage(form, overlay, labels) {
    var product = overlay.dataset.productTitle || '';
    var productUrl = overlay.dataset.productUrl || '';

    var name = getValue(form, 'contact[name]');
    var company = getValue(form, 'contact[company]');
    var email = getValue(form, 'contact[email]');
    var phone = getValue(form, 'contact[phone]');
    var body = getValue(form, 'contact[body]');

    var lines = [];
    lines.push("Hi Studio Ode! I'd like to inquire about bulk order gifting.");
    lines.push('');
    if (product) {
      lines.push('*Product*');
      lines.push(product);
      if (productUrl) lines.push(productUrl);
      lines.push('');
    }
    lines.push('*Contact*');
    lines.push((labels.name || 'Name') + ': ' + name);
    if (company) lines.push((labels.company || 'Company') + ': ' + company);
    lines.push((labels.email || 'Email') + ': ' + email);
    lines.push((labels.phone || 'WhatsApp') + ': ' + phone);
    if (body) {
      lines.push('');
      lines.push('*' + (labels.message || 'Message') + '*');
      lines.push(body);
    }
    return lines.join('\n');
  }

  function initBlock(root) {
    if (root.__odeCorpInit) return;
    root.__odeCorpInit = true;

    var blockId = root.dataset.blockId;
    if (!blockId) return;

    var openBtn = root.querySelector('[data-ode-corp-open="' + blockId + '"]');
    var overlay = root.querySelector('[data-ode-corp-overlay="' + blockId + '"]');
    if (!overlay) return;

    var closeBtns = overlay.querySelectorAll('[data-ode-corp-close="' + blockId + '"]');
    var formState = overlay.querySelector('[data-ode-corp-form]');
    var successState = overlay.querySelector('[data-ode-corp-success-state]');
    var form = overlay.querySelector('form.ode-corp-gifting__form');

    /* Pull field labels off the rendered <label> elements so the
       WhatsApp message uses whatever the merchant configured in the
       block settings (Full Name, Business Email, WhatsApp Number, etc.). */
    function getLabel(inputName) {
      var input = form && form.querySelector('[name="' + inputName + '"]');
      if (!input) return '';
      var id = input.id;
      var labelEl = id && form.querySelector('label[for="' + id + '"]');
      if (!labelEl) return '';
      /* Strip the trailing "*" or "(optional)" annotations so the message reads cleanly. */
      return (labelEl.textContent || '')
        .replace(/\(optional\)/gi, '')
        .replace(/\*/g, '')
        .trim();
    }

    function open() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ode-corp-gifting-open');
      document.body.style.overflow = 'hidden';
      setTimeout(function () {
        var firstInput = overlay.querySelector('input:not([type="hidden"]):not([disabled]), textarea:not([disabled])');
        if (firstInput && typeof firstInput.focus === 'function') firstInput.focus();
      }, 60);
    }

    function close() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ode-corp-gifting-open');
      document.body.style.overflow = '';
      /* Reset success state so the next open shows the form again. */
      if (formState) formState.classList.remove('is-hidden');
      if (successState) successState.classList.remove('is-visible');
    }

    function showSuccess() {
      if (formState) formState.classList.add('is-hidden');
      if (successState) successState.classList.add('is-visible');
    }

    if (openBtn) openBtn.addEventListener('click', open);

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        close();
      });
    });

    /* Outside click */
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    /* Escape key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });

    /* Submit → open WhatsApp with a drafted message.
       Client-side validation stops the submit if any required field is empty
       or the email is malformed; the browser's :invalid popover is surfaced
       via reportValidity() on the first invalid field. */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var invalidEl = form.querySelector(':invalid:not([type="hidden"])');
        if (invalidEl && typeof invalidEl.reportValidity === 'function') {
          invalidEl.reportValidity();
          return;
        }

        var labels = {
          name: getLabel('contact[name]'),
          company: getLabel('contact[company]'),
          email: getLabel('contact[email]'),
          phone: getLabel('contact[phone]'),
          message: getLabel('contact[body]')
        };

        var message = buildMessage(form, overlay, labels);
        var number = digitsOnly(overlay.dataset.whatsapp) || '85295769076';
        var waUrl = 'https://wa.me/' + number + '?text=' + encodeURIComponent(message);

        /* Swap to success state + open WhatsApp in a new tab. */
        showSuccess();
        window.open(waUrl, '_blank', 'noopener,noreferrer');
      });
    }
  }

  function boot() {
    document.querySelectorAll('.ode-corp-gifting[data-block-id]').forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor re-mount */
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();
